import { getSettings } from "@/core/lib/api/main/setting";
import { getSiteConfig } from "@/core/config/theme-config";

export async function OrganizationSchema() {
    try {
        const settings = await getSettings();
        const siteConfig = getSiteConfig();

        const organizationJsonLd = {
            '@context': 'https://schema.org',
            '@type': 'Organization',

            // ✅ API first, then env config, then empty
            name: settings?.site_title || siteConfig.siteTitle || '',
            url: process.env.NEXT_PUBLIC_SITE_URL || '',
            description: settings?.site_description || '',
            logo: settings?.logo_desktop || settings?.fav_icon,
            image: settings?.logo_desktop,

            // ✅ Contact info
            telephone: settings?.company_phone || settings?.company_mobile || '',
            email: settings?.admin_email || '',

            // ✅ Address
            address: settings?.company_address ? {
                '@type': 'PostalAddress',
                streetAddress: settings.company_address,
                addressLocality: 'Mashhad',
                addressCountry: 'IR',
            } : undefined,

            // ✅ Location coordinates
            ...(settings?.company_lat && settings?.company_lon ? {
                geo: {
                    '@type': 'GeoCoordinates',
                    latitude: settings.company_lat,
                    longitude: settings.company_lon,
                },
            } : {}),

            // ✅ Contact points
            contactPoint: [
                settings?.company_mobile ? {
                    '@type': 'ContactPoint',
                    telephone: settings.company_mobile,
                    contactType: 'sales',
                    availableLanguage: ['Persian'],
                } : null,
                settings?.after_sales_phone ? {
                    '@type': 'ContactPoint',
                    telephone: settings.after_sales_phone,
                    contactType: 'customer service',
                    availableLanguage: ['Persian'],
                } : null,
            ].filter(Boolean),

            // ✅ Social media (if you have Instagram in settings)
            ...(settings?.instagram ? {
                sameAs: [settings.instagram],
            } : {}),
        };

        // Remove undefined/null values
        const cleanJson = JSON.parse(JSON.stringify(organizationJsonLd));

        return (
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(cleanJson) }}
            />
        );
    } catch (error) {
        console.error('Organization schema failed:', error);
        return null;
    }
}